import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=3a0a7b60&scoped=true"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"
import style0 from "./Game.vue?vue&type=style&index=0&id=3a0a7b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0a7b60",
  null
  
)

export default component.exports